import React, { forwardRef } from 'react';

const wrapForReachUI = (Component?: any) => forwardRef((props?: any, ref?: any) => {
  // Convert @reach selected state to our own prop
  const highlighted = typeof props['data-selected'] !== 'undefined';

  return <Component highlighted={highlighted} ref={ref} {...props} />;
}) as any;

export default wrapForReachUI;
